import { render, staticRenderFns } from "./AddCouponRuleCpps.vue?vue&type=template&id=04930bc8&scoped=true"
import script from "./AddCouponRuleCpps.vue?vue&type=script&lang=js"
export * from "./AddCouponRuleCpps.vue?vue&type=script&lang=js"
import style0 from "./AddCouponRuleCpps.vue?vue&type=style&index=0&id=04930bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04930bc8",
  null
  
)

export default component.exports